import { ActivatedRouteSnapshot, ViewTransitionsFeatureOptions } from '@angular/router'

// Top-level sections whose inner navigations (e.g. /shop/packs -> /shop/tickets, the same page scrolling to
// another section) must not replay the page crossfade (see mos-animations.scss)
const SECTIONS_WITHOUT_INNER_TRANSITION = ['shop']

function urlPath(root: ActivatedRouteSnapshot): string[] {
	const segments: string[] = []
	for (let route: ActivatedRouteSnapshot | null = root; route; route = route.firstChild) {
		segments.push(...route.url.map((segment) => segment.path))
	}
	return segments
}

export const viewTransitionsOptions: ViewTransitionsFeatureOptions = {
	onViewTransitionCreated: ({ transition, from, to }) => {
		const fromSection = urlPath(from)[0]
		if (fromSection && SECTIONS_WITHOUT_INNER_TRANSITION.includes(fromSection) && urlPath(to)[0] === fromSection) {
			transition.skipTransition()
		}
	},
}
